import { render, staticRenderFns } from "./fault.vue?vue&type=template&id=52935e61&scoped=true&"
import script from "./fault.vue?vue&type=script&lang=js&"
export * from "./fault.vue?vue&type=script&lang=js&"
import style0 from "./fault.vue?vue&type=style&index=0&id=52935e61&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52935e61",
  null
  
)

export default component.exports